import { CheckoutCartMachineContext } from './types';

export const isCheckoutCartIdMissing = (
  context: CheckoutCartMachineContext,
) => {
  return !context.checkoutCartId;
};

export const isCartMissing = (context: CheckoutCartMachineContext) => {
  return context.checkoutCartId != null && !context.checkoutCart;
};

export const isUserNotReady = (context: CheckoutCartMachineContext) => {
  return !context.isUserReady;
};

export const areProductsMissing = (context: CheckoutCartMachineContext) => {
  return !context.products;
};
